var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "i-o-模型选择"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#i-o-模型选择"
    }
  }, [_vm._v("#")]), _vm._v(" I/O 模型选择")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("IO 模型")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("选择场景")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BIO")]), _vm._v(" "), _c('td', [_vm._v("所有 IO 事件都会阻塞线程，需要通过多线程来处理并发，会增加额外线程切换耗时，线程数越多，线程切换时间开销越大。造成 CPU 负载过大，但使用率不高，没能充分利用 CPU 资源")]), _vm._v(" "), _c('td', [_vm._v("无论什么情况下都不要使用 BIO，尽管在访问量低的情况下跟 NIO 差别不大并且 BIO 的 API 对代码编写要容易很多，但是 tomcat 已经封装了这部分 API，我们并不需要面向 socket 编程，所以不用考虑这个问题")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIO")]), _vm._v(" "), _c('td', [_vm._v("使用 epoll 多路复用 IO 模型，在等待数据就绪（从 IO 设备读取数据到系统内核）不需要阻塞线程，一次 select 可以查询多个 Channel 事件，但数据从系统内核读取到用户空间还是阻塞操作")]), _vm._v(" "), _c('td', [_vm._v("如果不是对性能要求极高，在绝大多数情况下这种处理方式已经足够。另外在 linux 平台对 NIO2 支持不是很完善，JVM 底层也是使用 epoll 来模拟 NIO2 的实现，跟 NIO 差别不大 ，所以linux 平台下选择 NIO")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIO2")]), _vm._v(" "), _c('td', [_vm._v("真正意义上的异步 IO，注册 IO 事件时传入回调函数，当数据就绪时调用回调函数完成数据处理")]), _vm._v(" "), _c('td', [_vm._v("windows 系统支持比较好，如果是 windows 下运行选 NIO2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("APR")]), _vm._v(" "), _c('td', [_vm._v("是 apache 可移植库，提供了一组映射到下层操作系统的 API，使用 C 语言实现，在 TCP 协议层做了优化，使用 sendfile 和 DirectByteBuffer 实现“零拷贝”，同时避免频繁 GC。同时还使用 OpenSSL 处理 TSL 握手和加解密，如果使用 https 能显著提升数据加解密性能")]), _vm._v(" "), _c('td', [_vm._v("对性能有极高要求或者是 https 场景下选择 APR")])])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "相关配置"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#相关配置"
    }
  }, [_vm._v("#")]), _vm._v(" 相关配置")]), _vm._v(" "), _c('div', {
    staticClass: "language-xml line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-xml"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!-- NIO -->")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Connector")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocol")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.coyote.http11.Http11NioProtocol"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!-- NIO2 -->")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Connector")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocol")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.coyote.http11.Http11Nio2Protocol"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!-- APR -->")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Connector")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocol")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.coyote.http11.Http11AprProtocol"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])]), _c('h3', {
    attrs: {
      "id": "apr-依赖库安装"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#apr-依赖库安装"
    }
  }, [_vm._v("#")]), _vm._v(" apr 依赖库安装")]), _vm._v(" "), _c('p', [_vm._v("官方文档："), _c('a', {
    attrs: {
      "href": "https://tomcat.apache.org/tomcat-8.5-doc/apr.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://tomcat.apache.org/tomcat-8.5-doc/apr.html"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('p', [_vm._v("依赖:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("APR 1.2+ development headers (libapr1-dev package)")]), _vm._v(" "), _c('li', [_vm._v("OpenSSL 1.0.2+ development headers (libssl-dev package)")]), _vm._v(" "), _c('li', [_vm._v("JNI headers from Java compatible JDK 1.4+")]), _vm._v(" "), _c('li', [_vm._v("GNU development environment (gcc, make)")])]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 安装依赖")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sudo")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("apt")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("install")]), _vm._v(" gcc cmake openssl\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 最新版本从 apr 官网下载 https://apr.apache.org/download.cgi")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("wget")]), _vm._v(" https://mirror.bit.edu.cn/apache//apr/apr-1.7.0.tar.gz\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("tar")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-zxvf")]), _vm._v(" apr-1.7.0.tar.gz\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("cd")]), _vm._v(" apr-1.7.0\n./configure "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sudo")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("install")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("wget")]), _vm._v(" https://mirror.bit.edu.cn/apache//apr/apr-util-1.6.1.tar.gz\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("tar")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-zxvf")]), _vm._v(" apr-util-1.6.1.tar.gz\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("cd")]), _vm._v(" apr-util-1.6.1\n./configure --with-apr"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _vm._v("/usr/local/apr  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sudo")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("install")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 安装 tomcat-native")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("cd")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${TOMCAT_HOME}")]), _vm._v("/bin\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("tar")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-zxvf")]), _vm._v(" tomcat-native.tar.gz\n./configure "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("&&")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sudo")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("make")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("install")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br')])]), _c('p', [_vm._v("apr 配置")]), _vm._v(" "), _c('div', {
    staticClass: "language-xml line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-xml"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!-- SSLEngine 是否启用 ssl -->")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Listener")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.core.AprLifecycleListener"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("SSLEngine")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("on"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Connector")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocol")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.coyote.http11.Http11AprProtocol"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br')])]), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Djava.library.path=/usr/local/apr/lib\"")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "线程池配置"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#线程池配置"
    }
  }, [_vm._v("#")]), _vm._v(" 线程池配置")]), _vm._v(" "), _c('p', [_vm._v("参数说明，在"), _c('code', [_vm._v("org.apache.catalina.core.StandardThreadExecutor")]), _vm._v("类定义")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("含义")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("threadPriority")]), _vm._v(" "), _c('td', [_vm._v("线程优先级，int，默认值 "), _c('code', [_vm._v("5")]), _vm._v(" - Thread.NORM_PRIORITY")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("daemon")]), _vm._v(" "), _c('td', [_vm._v("是否是 daemon 线程，boolean，默认值 "), _c('code', [_vm._v("true")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("namePrefix")]), _vm._v(" "), _c('td', [_vm._v("线程名称前缀，string，默认值 "), _c('code', [_vm._v("tomcat-exec-")])]), _vm._v(" "), _c('td', [_vm._v("后面会拼接线程编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxThreads")]), _vm._v(" "), _c('td', [_vm._v("最大线程数，int，默认值 "), _c('code', [_vm._v("200")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("minSpareThreads")]), _vm._v(" "), _c('td', [_vm._v("最小线程数，int，默认值 25")]), _vm._v(" "), _c('td', [_vm._v("当线程数超过"), _c('code', [_vm._v("minSpareThreads")]), _vm._v("时，多出的线程空闲一段时间会被回收。如果并发数较低，可以适当调小。并发数较高可适当增加")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxIdleTime")]), _vm._v(" "), _c('td', [_vm._v("线程最大空闲时间，int，默认值 "), _c('code', [_vm._v("60000")]), _vm._v(" 毫秒（1 分钟）")]), _vm._v(" "), _c('td', [_vm._v("线程空闲时间超过这个值会被回收，直到线程数剩下 minSpareThreads 个")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("prestartminSpareThreads")]), _vm._v(" "), _c('td', [_vm._v("是否在启动时就创建 minSpareThreads 个线程，boolean，默认值 "), _c('code', [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("如果是并发比较高，可以设置为"), _c('code', [_vm._v("true")]), _vm._v("，在启动时对线程池预热。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxQueueSize")]), _vm._v(" "), _c('td', [_vm._v("线程池队列长度，int，默认值 "), _c('code', [_vm._v("Integer.MAX_VALUE")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])]), _vm._v(" "), _c('p', [_vm._v("与"), _c('a', {
    attrs: {
      "href": "/java/juc/thread/thread-pool"
    }
  }, [_vm._v("java 线程池")]), _vm._v("不同，tomcat 自定义了一个线程池实现，当执行任务线程数 < "), _c('code', [_vm._v("maxThreads")]), _vm._v(" 时，会创建新的线程来执行任务，当 执行任务线程数 = "), _c('code', [_vm._v("maxThreads")]), _vm._v(" 时，新提交的任务才会放到队列中等待执行。")]), _vm._v(" "), _c('p', [_vm._v("最关键的参数是如何设置"), _c('code', [_vm._v("maxThreads")]), _vm._v("，最大化利用 CPU 资源")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("设置小了，可能导致请求进入队列等待，随着并发数的增加 CPU 负载和使用率都没有增加，不能充分利用 CPU")]), _vm._v(" "), _c('li', [_vm._v("设置大了，会增加额外线程切换时间，随着并发数的增加 CPU 负载增加，但是使用率没有显著增加，同样没有充分利用 CPU")])]), _vm._v(" "), _c('p', [_vm._v("线程池大小计算公式：maxThreads = 每秒请求数 * 平均请求耗时 * CPU 核心数")]), _vm._v(" "), _c('p', [_vm._v("用单核 CPU 举例")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("需要线程数")]), _vm._v(" "), _c('th', [_vm._v("QPS（每秒请求数）")]), _vm._v(" "), _c('th', [_vm._v("平均请求耗时（秒）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("500")]), _vm._v(" "), _c('td', [_vm._v("500")]), _vm._v(" "), _c('td', [_vm._v("1")])])])]), _vm._v(" "), _c('p', [_vm._v("所以只要能知道"), _c('code', [_vm._v("QPS")]), _vm._v("和"), _c('code', [_vm._v("平均请求耗时")]), _vm._v("就可以确定线程数")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("QPS")]), _vm._v(" "), _c('p', [_vm._v("通过统计 accesslog 可以获得，统计的方法很多，例如可以用 elk 收集（这里不展开），在 kibana 上查询。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./01.kibana-accesslog.png"),
      "alt": "accesslog"
    }
  })])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("平均请求耗时")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("平均请求耗时 = IO 阻塞时间 + CPU 处理时间")]), _vm._v(" "), _c('li', [_vm._v("平均请求耗时 = IO 阻塞时间 + CPU 计算时间 + 线程上下文切换时间")])]), _vm._v(" "), _c('p', [_vm._v("对于 IO 密集型的程序，请求耗时住要包括"), _c('code', [_vm._v("IO 阻塞时间")]), _vm._v("和"), _c('code', [_vm._v("CPU 处理时间")]), _vm._v("。"), _c('code', [_vm._v("IO 阻塞时间")]), _vm._v("和"), _c('code', [_vm._v("CPU 计算时间")]), _vm._v("在服务稳定的情况下比较稳定的。只有线程上下文切换时间会随着线程数增加而增加，所以当线程过多时，再增加新的线程不一定能提升吞吐量（线程过多导致 CPU 大部分时间都在做线程切换而不是计算，也就是总的平均请求时间也会增加），所以线程数太多或太少都会影响服务吞吐量。我们可以在访问量较低的时候统计出平均耗时，然后根据公式计算出一个初始值，反复压测增加或减少调整线程数，得到一个最优值。平均请求时间的计算同样可以通过 accesslog 计算，响应时间总和 / 请求次数")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "监控"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#监控"
    }
  }, [_vm._v("#")]), _vm._v(" 监控")]), _vm._v(" "), _c('p', [_vm._v("服务在 7 * 24 小时运行过程中各项数据都可能发生变化，比如：并发数、平均请求时间（随着数据量增加，相同的数据查询耗时也会增加，另外随着需求的不断迭代，代码的复杂度也会增加）。所以非常有必要对服务的指标（吞吐量、响应时间、错误数、线程池、CPU 以及 JVM 内存等）做监控，通过监控判断服务运行是否监控，参数配置是否合理。")]), _vm._v(" "), _c('p', [_vm._v("Tomcat 通过暴露 JMX 接口提供给开发、运维人员查询相关数据，只需要在启动的时候添加以下 JMX 配置参数，然后通过 jdk 提供的 jconsole 工具连接 JMX 接口就可以可视化观察 Tomcat 运行状态。")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.port=9001\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Djava.rmi.server.hostname=0.0.0.0\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.ssl=false\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br')])]), _c('p', [_vm._v("用 jconsole 连接 Tomcat JMX")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("jconsole "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("192.168")]), _vm._v(".3.3:9001\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br')])]), _c('p', [_c('img', {
    attrs: {
      "src": require("./01.jconsole-overview.png"),
      "alt": "jconsole"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("常见问题：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("当看到 GC 频繁时，可以适当调整堆大小，如果是 CMS 收集器，YGC 次数频繁，则适当增加新生代空间。FGC 频繁，则适当增加老年代空间")]), _vm._v(" "), _c('li', [_vm._v("当系统 QPS 没有明显增加，但是活跃线程数增加较多时，说明平均耗时增加了，需要排查下游服务具体是什么原因导致请求平均耗时增加")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "完整配置参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#完整配置参考"
    }
  }, [_vm._v("#")]), _vm._v(" 完整配置参考")]), _vm._v(" "), _c('p', [_vm._v("tomcat 版本：8.5.x")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("bin/setenv.sh")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# tomcat.pid")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("CATALINA_PID")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("$CATALINA_BASE")]), _vm._v("/logs/tomcat.pid\"")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("LOG_PATH")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"/path/to/log\"")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# jvm")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# JAVA_HOME=/path/to/java")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"-Djava.security.egd=file:/dev/urandom -Dfile.encoding=UTF-8\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"-Xmx4G -Xms4G -XX:MaxMetaspaceSize=512M -XX:MetaspaceSize=512M -XX:+UseG1GC -XX:MaxGCPauseMillis=50 -XX:+ParallelRefProcEnabled\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"-XX:ErrorFile="), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${LOG_PATH}")]), _vm._v("/hs_err_pid%p.log -XX:+HeapDumpOnOutOfMemoryError -XX:HeapDumpPath="), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${LOG_PATH}")]), _vm._v(" -XX:+HeapDumpBeforeFullGC -XX:+HeapDumpAfterFullGC -Xloggc:"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${LOG_PATH}")]), _vm._v("/gc.log -XX:+PrintGCDetails -XX:+PrintGCDateStamps -XX:+PrintCommandLineFlags\"")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# apr")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Djava.library.path=/usr/local/apr/lib\"")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# jmx")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.port=9001\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Djava.rmi.server.hostname=0.0.0.0\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.ssl=false\"")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("JAVA_OPTS")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\""), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("${JAVA_OPTS}")]), _vm._v(" -Dcom.sun.management.jmxremote.authenticate=false\"")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token assign-left variable"
    }
  }, [_vm._v("UMASK")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"0022\"")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("19")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("20")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("21")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("22")]), _c('br')])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("conf/server.xml")]), _vm._v(" "), _c('div', {
    staticClass: "language-xml line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-xml"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token prolog"
    }
  }, [_vm._v("<?xml version=\"1.0\" encoding=\"UTF-8\"?>")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Server")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("port")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("8005"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("shutdown")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("SHUTDOWN"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!-- Security listener. Documentation at /docs/config/listeners.html\n    <Listener className=\"org.apache.catalina.security.SecurityListener\" />\n    -->")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("<!--APR library loader. Documentation at /docs/apr.html \n    <Listener className=\"org.apache.catalina.core.AprLifecycleListener\" SSLEngine=\"on\" />\n    -->")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Listener")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.startup.VersionLoggerListener"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Listener")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.core.JreMemoryLeakPreventionListener"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Listener")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.mbeans.GlobalResourcesLifecycleListener"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Listener")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.core.ThreadLocalLeakPreventionListener"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n\n\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Service")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("name")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("Catalina"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n\n        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Executor")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("name")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("tomcatThreadPool"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v("   "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("namePrefix")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("tomcat-thread-pool-exec-"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("prestartminSpareThreads")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("true"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("maxThreads")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("2000"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("maxQueueSize")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("100"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("minSpareThreads")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("50"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("maxIdleTime")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("10000"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n\n        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Connector")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("port")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("8081"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocol")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.coyote.http11.Http11NioProtocol"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("enableLookups")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("false"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("connectionTimeout")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("15000"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("redirectPort")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("8443"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("executor")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("tomcatThreadPool"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("compression")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("on"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("compressableMimeType")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("text/html,text/xml,text/plain,text/css,text/javascript,application/javascript"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("URIEncoding")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("utf-8"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n\n        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Engine")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("name")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("Catalina"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("defaultHost")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("localhost"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Host")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("name")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("localhost"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("appBase")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("webapps"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n\n                    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Valve")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.valves.RemoteIpValve"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("remoteIpHeader")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("x-real-ip"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("proxiesHeader")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("x-forwarded-by"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("protocolHeader")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("x-forwarded-proto"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n                    \n                    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Valve")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("className")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("org.apache.catalina.valves.AccessLogValve"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("directory")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("logs"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v("\n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("prefix")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("access_log"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("suffix")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v(".log"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v("\n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("pattern")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("%h %l %u %t "), _c('span', {
    pre: true,
    attrs: {
      "class": "token entity named-entity",
      "title": "\""
    }
  }, [_vm._v("&quot;")]), _vm._v("%r"), _c('span', {
    pre: true,
    attrs: {
      "class": "token entity named-entity",
      "title": "\""
    }
  }, [_vm._v("&quot;")]), _vm._v(" %s %b"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("/>")])]), _vm._v("\n\n                    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Context")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("docBase")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("/path/to/app/demo"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("path")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("reloadable")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("false"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("sessionCookiePath")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("/"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("sessionCookieName")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("APP_SESSION"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _vm._v(" \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("useHttpOnly")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("true"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n                        \n                        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("<")]), _vm._v("Resources")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-name"
    }
  }, [_vm._v("allowLinking")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token attr-value"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation attr-equals"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")]), _vm._v("true"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("\"")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Resources")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n                    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Context")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Host")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Engine")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Service")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token tag"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("</")]), _vm._v("Server")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(">")])]), _vm._v("\n\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("19")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("20")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("21")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("22")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("23")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("24")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("25")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("26")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("27")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("28")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("29")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("30")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("31")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("32")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("33")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("34")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("35")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("36")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("37")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("38")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("39")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("40")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("41")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("42")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("43")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("44")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("45")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("46")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("47")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("48")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("49")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("50")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("51")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("52")]), _c('br')])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "官方配置说明"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#官方配置说明"
    }
  }, [_vm._v("#")]), _vm._v(" 官方配置说明")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://tomcat.apache.org/tomcat-8.5-doc/config/http.html#Connector_Comparison",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://tomcat.apache.org/tomcat-8.5-doc/config/http.html#Connector_Comparison"), _c('OutboundLink')], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };